export * from './constants.defaults.js'

/**
 * @see https://libp2p.github.io/js-libp2p/interfaces/libp2p.index.ConnectionManagerInit.html#maxConnections
 */
export const MAX_CONNECTIONS = 100

/**
 * @see https://libp2p.github.io/js-libp2p/interfaces/libp2p.index.ConnectionManagerInit.html#maxParallelDials
 */
export const MAX_PARALLEL_DIALS = 50
